import { fetchWithBaseUrl } from '../../utils/api'

export type UploadImageParams = {
	props: {
		imageKey: string
		bucket: string
		imageKeyPrev?: string
		nextPublicSecretToken?: string
	}
	file?: File | Blob
	buffer?: Buffer
	contentType?: string
	andThen?: Function
	env: string
}

const uploadImage = async (propsAndFile: UploadImageParams) => {
	try {
		const response = await fetchWithBaseUrl(`presignUrl`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				fileName: propsAndFile.props.imageKey,
				contentType: propsAndFile?.contentType ?? propsAndFile?.file?.type,
				bucket: propsAndFile.props.bucket,
			}),
		})
		if (response.ok) {
			const data = await response.json()

			try {
				console.log('sent put type:', propsAndFile.file ?? propsAndFile.buffer)
				const headers = {
					'Content-Type':
						propsAndFile?.contentType ?? propsAndFile?.file?.type ?? '',
				}

				const requestOptions = {
					method: 'PUT',
					headers: headers,
					body: propsAndFile.file ?? propsAndFile.buffer,
				}

				try {
					const uploadResponse = await fetch(data.preSignedUrl, requestOptions)
					// Handle the response here

					if (propsAndFile.andThen) {
						return propsAndFile.andThen()
					} else {
						return {
							data,
							uploadResponse,
						}
					}
				} catch (error) {
					console.error('Error uploading image:', error)
					// Handle the error here
				}
			} catch (error) {
				console.error(error)
				return
			}
		}
	} catch (error) {
		console.error(error)

		return {}
	}
}

export default uploadImage
